import { useContext, useEffect, useCallback } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

// components
import Confirm from "components/ui/Confirm";

export function useBlocker(blocker, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    // @ts-nocheck
    const unblock = navigator?.block
      ? navigator.block((tx) => {
          const autoUnblockingTx = {
            ...tx,
            retry() {
              unblock();
              tx.retry();
            },
          };
          blocker(autoUnblockingTx);
        })
      : () => {};
    return unblock;
  }, [navigator, blocker, when]);
}

export function usePrompt(title, message, when = true) {
  const blocker = useCallback(
    (tx) => {
      Confirm(message, {
        title: title,
        button: {
          left: { name: "취소", color: "gray20" },
          right: { name: "확인", color: "primary50" },
        },
        callback: (res) => {
          if (res) tx.retry();
          else return;
        },
      });
    },
    [title, message]
  );

  useBlocker(blocker, when);
}
